import * as React from "react";

function SvgMail(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 18 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18 2.6c0-.99-.81-1.8-1.8-1.8H1.8C.81.8 0 1.61 0 2.6v10.8c0 .99.81 1.8 1.8 1.8h14.4c.99 0 1.8-.81 1.8-1.8V2.6zm-1.8 0L9 7.1 1.8 2.6h14.4zm0 10.8H1.8v-9L9 8.9l7.2-4.5v9z"
        fill="#131B1F"
      />
    </svg>
  );
}

export default SvgMail;
